import { SortingState } from "@tanstack/react-table";
import { PlusInSquareIcon } from "assets/icons";
import { useBoolean } from "hooks";
import { t } from "i18next";
import { useMemo, useState } from "react";
import { Button, SearchInput } from "ui";

import { useWarehouses } from "../../apis";
import { WarehousesTable } from "../../components";
import { DeleteWarehouseModal, WarehouseFormModal } from "../../features";
import { IWarehouse } from "../../warehouses.types";

import styles from "./Warehouses.module.scss";

const Warehouses = () => {
  const { warehouses, isLoading } = useWarehouses();
  const [searchValue, setSearchValue] = useState("");
  const [sorting, setSorting] = useState<SortingState>([]);
  const [editableWarehouse, setEditableWarehouse] = useState<IWarehouse | null>(
    null,
  );
  const [deletableWarehouse, setDeletableWarehouse] =
    useState<IWarehouse | null>(null);

  const {
    value: isFormOpen,
    setTrue: openForm,
    setFalse: closeForm,
  } = useBoolean(false);

  const filtered = useMemo(() => {
    const query = searchValue.trim().toLowerCase();
    if (!query) return warehouses;
    return warehouses.filter((warehouse) =>
      warehouse.name.toLowerCase().includes(query),
    );
  }, [warehouses, searchValue]);

  const onCreate = () => {
    setEditableWarehouse(null);
    openForm();
  };

  const onEdit = (warehouse: IWarehouse) => {
    setEditableWarehouse(warehouse);
    openForm();
  };

  const onCloseForm = () => {
    setEditableWarehouse(null);
    closeForm();
  };

  return (
    <div className={styles.warehouses}>
      <div className={styles.warehouses_headerControls}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          placeholder={`${t("Search")}...`}
        />

        <Button
          title={t("New Warehouse")}
          icon={<PlusInSquareIcon />}
          onClick={onCreate}
        />
      </div>

      <div className={styles.warehouses_tableContainer}>
        <WarehousesTable
          warehouses={filtered}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
          onEdit={onEdit}
          onDelete={setDeletableWarehouse}
        />
      </div>

      <WarehouseFormModal
        isOpen={isFormOpen}
        warehouse={editableWarehouse}
        onClose={onCloseForm}
      />

      <DeleteWarehouseModal
        isOpen={!!deletableWarehouse}
        warehouse={deletableWarehouse}
        onClose={() => setDeletableWarehouse(null)}
      />
    </div>
  );
};

export default Warehouses;
